import React, { useState } from 'react';
import ConfirmationModal from '../Components/ConfirmationModal';

const useConfirmationModal = () => {
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);

  const modal = ({ acceptText = '', onAccept = () => {} }) => (
    <ConfirmationModal
      acceptText={acceptText}
      close={() => {
        setOpenConfirmationModal(!openConfirmationModal);
      }}
      open={openConfirmationModal}
      onAccept={onAccept}
    />
  );

  return {
    ConfirmationModal: modal,
    openConfirmationModal,
    setOpenConfirmationModal,
  };
};

export default useConfirmationModal;
